import { CustomerTypesInversedKeys } from '@teinor/erp/types/company/customer/customerTypes'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { getConfigParam } from '../../../../../utils/reducers/getters'
import locations from '../../../../../utils/globals/locations'
import useCustomerTypesDict from '../../../../../utils/hooks/customer/useCustomerTypesDict'

export type CustomerTabKeys = 'tasks' | 'people' | 'projects' | 'sells' | 'customer' | 'activity' | 'bagsOfHours' | 'bank' | 'address' | 'campaigns' | 'notes' | 'opportunities'

interface GetCustomerParsedLinkLogicProps {
    customerType: CustomerTypesInversedKeys
    tab: CustomerTabKeys
}

export const useGetCustomerParsedLinkLogic = ({ customerType, tab }: GetCustomerParsedLinkLogicProps) => {
    const { id } = useParams()
    const { dictTypeCustomerLink } = useCustomerTypesDict()
    const typeCustomer: CustomerTypesInversedKeys = customerType || 0
    const parsedLink = useMemo(() => {
        const showAllCustomersTogether = getConfigParam('showAllCustomersTogether') === 'on' ? true : false
        const dictTypePathLink: Record<CustomerTabKeys, string> = {
            tasks: '/tasks',
            customer: '/general',
            people: '/people',
            projects: '/projects',
            sells: '/sells',
            activity: '/activity',
            notes: '/activity',
            bagsOfHours: '/bagsOfHours',
            bank: '/bank',
            address: '/address',
            campaigns: '/campaigns',
            opportunities: '/opportunities'
        }
        
        return locations.customer + '/' + (showAllCustomersTogether ? 'allCustomers' : dictTypeCustomerLink[typeCustomer]) + '/' + id + dictTypePathLink[tab]
    }, [typeCustomer, id, tab, dictTypeCustomerLink])

    return { parsedLink }
}